import type { Briefing } from '@acasa/shared'

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—'
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return '—'
  return date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—'
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return '—'
  return date.toLocaleString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

/** "380 kB", "4,2 MB" — the visible measure of a briefing's size (D7). */
export function formatBytes(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined) return '—'
  if (bytes < 1_000_000)
    return `${Math.max(1, Math.round(bytes / 1000)).toLocaleString('de-DE')} kB`
  return `${(bytes / 1_000_000).toLocaleString('de-DE', { maximumFractionDigits: 1 })} MB`
}

/** The document's name, worded once in `@acasa/shared` for the PDF and the page. */
export { briefingAddress, briefingDocumentName as briefingName } from '@acasa/shared'

/** "Stand" is when the run finished; until then, when it was asked for. */
export function briefingStand(briefing: Briefing): string {
  return formatDate(briefing.finishedAt ?? briefing.createdAt)
}

export function fileLabel(file: { title: string | null; originalName: string | null; id: number }) {
  return file.title?.trim() || file.originalName?.trim() || `Datei ${file.id}`
}

/**
 * The fixed line for briefings that cannot run on this server. Provider-neutral
 * on purpose: the provider is chosen under Einstellungen, and either one can be
 * the one without a key. The key is set up on the server, never in the app.
 */
export const NOT_CONFIGURED =
  'Objekt-Briefings sind nicht konfiguriert — für den eingestellten Anbieter ist auf dem Server kein API-Schlüssel eingerichtet.'
